var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('box',{staticClass:"battle-box",attrs:{"shadow":"large","noPadding":true}},[_c('div',{staticClass:"battle-box__top"},[_vm._t("top")],2),(_vm.$slots['bottom'])?_c('div',{staticClass:"battle-box__bottom"},[_vm._t("bottom")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }